import React,{useMemo} from "react";
import {Navigate, useLocation} from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import SessionDataStorer from "../../../dataAccessLayer/session/SessionDataStorer";
import SessionKey from "../../../dataAccessLayer/session/SessionKey";
import JsTypeInspector from "../../../serviceLayer/validators/JsTypeInspector";
import LocalStorageDataStorer from "../../../dataAccessLayer/localStorage/LocalStorageDataStorer";
import LocalStorageKey from "../../../dataAccessLayer/localStorage/LocalStorageKey";


export default function ResourceProtector({ children, resource, rejectionRoute }) {
    const location = useLocation();

    const authStatus = useMemo(() => {
        try{
            //console.log("ResourceProtector-children", children);
            //console.log("ResourceProtector-resource", resource);
            //console.log("ResourceProtector-rejectionRoute", rejectionRoute);
            const session = SessionDataStorer.getSessionFromCookieStorage(SessionKey.sessionID);
            const isAuthenticated = !JsTypeInspector.stringIsNullOrEmpty(session);
            if (!isAuthenticated) return { authenticated: false, authorized: false };

            const jwtUserToken = LocalStorageDataStorer.getItemFromLocalStorage(LocalStorageKey.jwtUserToken);
            if (!jwtUserToken) return { authenticated: true, authorized: false };
            
            const decodedToken = jwtDecode(jwtUserToken);
            //console.log("ResourceProtector-decodedToken", decodedToken);
            const userClaims = decodedToken?.policy?.claimsAndPermissions?.customer || {};
            //console.log("ResourceProtector-userClaims", userClaims);
            const userCanClaimAccessToResource = userClaims[resource.name];
            const isAuthorized = !JsTypeInspector.objectIsNullOrEmpty(userCanClaimAccessToResource);

            return { authenticated: true, authorized: isAuthorized };
        } catch (error) {
            console.error("ResourceProtector: Error processing authentication", error);
            return { authenticated: false, authorized: false };
        }
    }, [resource.name]);

    if (!authStatus.authenticated || !authStatus.authorized) {
        console.warn(`ResourceProtector: Access denied to ${resource.name}. Redirecting to ${rejectionRoute}`);
        
        return (
            <Navigate 
                to={rejectionRoute} 
                state={{ from: location.pathname }} 
                replace 
            />
        );
    }

    return children;
}